/** Il contesto che il guscio dell'allenamento passa alle sue schede. */

import { useOutletContext } from 'react-router-dom';
import type { DettaglioAllenamento, StatoAllenamento } from './allenamenti.js';

export interface ContestoAllenamento {
  dettaglio: DettaglioAllenamento;
  /** Ricarica l'allenamento senza togliere la testata. */
  ricarica: () => Promise<void>;
  /** Lo stato cambiato da una scheda (l'appello lo chiude), per il badge della testata. */
  aggiornaStato: (stato: StatoAllenamento) => void;
}

/** L'allenamento del guscio, per le schede. */
export const useAllenamento = () => useOutletContext<ContestoAllenamento | undefined>();
